import React, { useEffect, useRef, useState } from 'react';
import OpportunityTable from '../components/opportunities/OpportunityTable';
import useAxiosProtect from '../hooks/useAxiosProtect';

const SiteOppList = props => {
    var init = useRef(true);
    const [siteName, setSiteName] = useState('');
    const [oppCount, setOppCount] = useState(0);

    const axiosProtect = useAxiosProtect();

    useEffect(() => {
        if(!init.current) return;
        init.current = false;

        axiosProtect.get(`/opp/opportunities/site-opp-metadata?siteID=${window.location.href.split('/').slice(-1)}`).then(response => {
            setSiteName(response.data.siteName);
            setOppCount(response.data.oppCount);
        }).catch(error => {

        });
    }, []);

    return (
        <div style={{padding:'1vh 2vw'}}>
            <h4>{siteName} opportunities ({oppCount})</h4>
            <br/>
            <OpportunityTable siteID={window.location.href.split('/').slice(-1)} hideDelete={true}/>
        </div>
    );
}

export default SiteOppList;